const scaleFormSet = {}

export { scaleFormSet }
